import React from 'react'
import PropTypes from 'prop-types'

const Select = ({ label, value, options, onChange }) => {
  return (
    <div className="flex items-center mb-2">
      <label htmlFor="name" className="text-right w-16">
        {label}:
      </label>
      <select
        className="flex-1 p-2 ml-4 input appearance-none bg-gray-50"
        id={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.length &&
          options.map((option, key) => (
            <option key={key} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
    </div>
  )
}

Select.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default Select
